import {
  AimOutlined,
  AppstoreOutlined,
  BankOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DockerOutlined,
  FlagOutlined,
  GoldOutlined,
  ThunderboltOutlined,
  ToolOutlined
} from "@ant-design/icons";
import { Card, Divider, Tag, Typography } from "antd";
import { S3_BASE_URL } from "../services/apiConstants";

const DetailItem = ({ icon, label, value }) => (
  <div className="detail-item-interactive" style={{ display: 'flex', alignItems: 'flex-start', fontSize: '14px', marginBottom: '8px' }}>
    <span className="icon-badge" style={{ marginRight: '12px', marginTop: '2px', fontSize: '16px' }}>{icon}</span>
    <span style={{ color: '#64748b', width: '120px', flexShrink: 0, fontWeight: 500 }}>{label}</span>
    <span style={{ color: '#1e293b', fontWeight: 600, wordBreak: "break-word" }}>{value || '-'}</span>
  </div>
);

const ShipDetailsCard = ({ ship }) => {
  const photoPath = Array.isArray(ship?.image_ship) ? ship.image_ship[0] : ship?.image_ship;
  const fullUrl = ship?.image_ship ? `${S3_BASE_URL}${photoPath}` : "/assets/images/default-ship.png";
  return (
    <Card
      className="hover-lift-card"
      style={{ borderRadius: "20px", boxShadow: "0 10px 40px -10px rgba(0,0,0,0.08)", overflow: "hidden", border: "1px solid rgba(255,255,255,0.4)", backdropFilter: "blur(20px)", background: "rgba(255,255,255,0.85)", height: "100%" }}
      bodyStyle={{ padding: 0, height: "100%", display: "flex", flexDirection: "column" }}
    >
      <div style={{ padding: "24px", flex: 1, backgroundColor: "transparent" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "16px" }}>
            <div>
              <Typography.Title level={4} style={{ margin: 0, fontWeight: 800, color: "#001529", letterSpacing: "-0.5px", display: "flex", alignItems: "center" }}>
                <DockerOutlined className="mr-2" style={{ color: '#E11236', marginRight: '10px', fontSize: '24px' }}/>
                {ship?.vessel_name || "Unknown Vessel"}
              </Typography.Title>
            </div>
            <Tag
              color={ship?.status ? "success" : "error"}
              style={{ borderRadius: "20px", padding: "6px 14px", border: "none", fontWeight: 600, fontSize: "14px" }}
            >
              {ship?.status ? <><CheckCircleOutlined /> Active</> : <><CloseCircleOutlined /> Inactive</>}
            </Tag>
        </div>

        <Divider style={{ margin: "16px 0", borderColor: "#f1f5f9" }} />

        <div style={{ display: "flex", flexDirection: "column", gap: "2px", overflowY: "auto", overflowX: "hidden", maxHeight: "300px", paddingRight: "8px" }}>
            <DetailItem icon={<FlagOutlined style={{ color: '#E11236' }}/>} label="Flag" value={ship?.flag} />
            <DetailItem icon={<ToolOutlined style={{ color: '#0ea5e9' }}/>} label="Type" value={ship?.ship_type} />
            <DetailItem icon={<BankOutlined style={{ color: '#8b5cf6' }}/>} label="Class" value={ship?.ship_class} />
            <DetailItem icon={<GoldOutlined style={{ color: '#f59e0b' }}/>} label="Deadweight" value={`${ship?.deadweight || '-'} Tons`} />
            <DetailItem icon={<AimOutlined style={{ color: '#10b981' }}/>} label="Max Draft" value={`${ship?.maximum_draft || '-'} m`} />
            <DetailItem icon={<ToolOutlined style={{ color: '#ec4899' }}/>} label="Main Engine" value={`${ship?.main_engine_make || '-'} (${ship?.main_engine_model || '-'})`} />
            <DetailItem icon={<ThunderboltOutlined style={{ color: '#eab308' }}/>} label="Power (MCR)" value={`${ship?.power_rpm_mcr || '-'} RPM`} />
            <DetailItem icon={<AppstoreOutlined style={{ color: '#6366f1' }}/>} label="Cylinders" value={ship?.no_of_cylinder} />
        </div>
      </div>
      
      <div style={{ height: "240px", backgroundColor: "#f8fafc", overflow: "hidden" }}>
        <img
          className="hero-image-zoom"
          alt={ship?.vessel_name || "Image"}
          src={fullUrl}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/assets/images/default-ship.png"; // Fallback image path
          }}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderTop: "1px solid rgba(255,255,255,0.6)"
          }}
        />
      </div>
    </Card>
  );
};

export default ShipDetailsCard;
